export default __webpack_public_path__ + "static/media/Logo.dc2de91f.svg";